// WARNING: DO NOT EDIT. This file is Auto-Generated by AWS Mobile Hub. It will be overwritten.

// Copyright 2017-2018 Amazon.com, Inc. or its affiliates (Amazon). All Rights Reserved.
// Code generated by AWS Mobile Hub. Amazon gives unlimited permission to
// copy, distribute and modify it.

// AWS Mobile Hub Project Constants
const awsmobile = {
    // 'aws_app_analytics': 'enable',
    'aws_cloud_logic': 'enable',
    'aws_cloud_logic_custom': [{"id":"jec8wza0c5","name":"multimedia-checklist","description":"API Gateway for dentistfind multimedia app","endpoint":"https://jec8wza0c5.execute-api.us-east-2.amazonaws.com/prod","region":"us-east-2","paths":["/account","/account/{email}","/account/{email}/enable","/company","/questions","/questions/{id}","/shoot","/shoot/{clinic}/{created_at}","/shoot/{clinic}/{created_at}/details","/shoot/{clinic}/{created_at}/intro-outro","/shoot/{clinic}/{created_at}/language","/shoot/{clinic}/{created_at}/language/{language}","/shoot/{clinic}/{created_at}/questions","/shoot/{clinic}/{created_at}/questions/{id}","/shoot/{clinic}/{created_at}/questions/{id}/{user}/done","/shoot/{clinic}/{created_at}/questions/{id}/{user}/un-done","/shoot/{clinic}/{created_at}/service","/shoot/{clinic}/{created_at}/service/{service}","/shoot/{clinic}/{created_at}/shots","/shoot/{clinic}/{created_at}/shots/check","/shoot/{clinic}/{created_at}/shots/{shotId}","/shoot/{clinic}/{created_at}/staff","/shoot/{clinic}/{created_at}/staff/{email}","/shoot/{clinic}/{created_at}/status","/shooter/{id}","/shot","/shot/{id}","/unselected"]}],
    'aws_cognito_identity_pool_id': 'us-east-2:690504ff-eeed-4046-93bf-1a8617e49a97',
    'aws_cognito_region': 'us-east-2',
    'aws_mandatory_sign_in': 'enable',
    // 'aws_mobile_analytics_app_id': 'd798509c67484a17ad40f13a482431f6',
    // 'aws_mobile_analytics_app_region': 'us-east-1',
    'aws_project_id': '199c2151-d934-402b-8d49-8a358db3dcb5',
    'aws_project_name': 'shooters-prod',
    'aws_project_region': 'us-east-2',
    'aws_resource_name_prefix': 'shootersprod-mobilehub-1182704948',
    'aws_sign_in_enabled': 'enable',
    'aws_user_files': 'enable',
    'aws_user_files_s3_bucket': 'shootersprod-userfiles-mobilehub-1182704948',
    'aws_user_files_s3_bucket_region': 'us-east-2',
    'aws_user_pools': 'enable',
    'aws_user_pools_id': 'us-east-2_Gx723dd54',
    'aws_user_pools_web_client_id': '2knnadf91s79qeq5mldt11t4rf',
}

export default awsmobile;
